class CartStandTitle extends HTMLElement {
  #resizeObserver = null;
  #canHover = false;

  connectedCallback() {
    if (!this.closest('.cart-drawer')) return;

    this.#canHover = window.matchMedia?.('(hover: hover)').matches ?? false;
    this.#refreshOverflow();

    if ('ResizeObserver' in window) {
      this.#resizeObserver = new ResizeObserver(this.#refreshOverflow);
      this.#resizeObserver.observe(this);
    } else {
      window.addEventListener('resize', this.#refreshOverflow);
    }

    if (this.#canHover) {
      this.addEventListener('pointerenter', this.#handlePointerEnter);
      this.addEventListener('pointerleave', this.#handlePointerLeave);
    }
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    window.removeEventListener('resize', this.#refreshOverflow);
    this.removeEventListener('pointerenter', this.#handlePointerEnter);
    this.removeEventListener('pointerleave', this.#handlePointerLeave);
  }

  #refreshOverflow = () => {
    if (this.dataset.hovered === 'true') return;

    const text = this.querySelector('strong');
    if (!(text instanceof HTMLElement)) return;

    const isOverflowing = text.scrollWidth > text.clientWidth + 1;
    this.dataset.overflow = String(isOverflowing);

    if (!isOverflowing) {
      this.removeAttribute('data-hovered');
      this.scrollLeft = 0;
    }
  };

  #handlePointerEnter = () => {
    if (this.dataset.overflow !== 'true') return;

    this.dataset.hovered = 'true';
    requestAnimationFrame(() => {
      if (!this.isConnected || this.dataset.overflow !== 'true' || this.dataset.hovered !== 'true') return;

      this.scrollTo({
        left: this.scrollWidth,
        behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    });
  };

  #handlePointerLeave = () => {
    this.removeAttribute('data-hovered');
    this.scrollTo({
      left: 0,
      behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  };
}

if (!customElements.get('cart-stand-title')) {
  customElements.define('cart-stand-title', CartStandTitle);
}
